import { pushRoute } from '../../../../../lib/router.js';
import React, { useState } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  createChangeInsight,
  deleteChangeInsightTemplate,
  duplicateChangeInsightTemplate,
  retrieveTemplatesFeedbackForm,
} from '../../../../../modules/changeInsights.js';
import { updateAutoHiddenNotificationState } from '../../../../../modules/notifications.js';
import { DuplicateIcon } from '../../../../icons/DuplicateIcon.jsx';
import { EditBlueIcon } from '../../../../icons/EditBlueIcon.jsx';
import { isAuthorized } from '../../../../AuthorizedAction.js';
import { DeleteBlueIcon } from '../../../../icons/DeleteBlueIcon.jsx';
import { selectUserPermissions } from '../../../../../modules/auth.js';
import { getOrgTermsContent } from '../../../../../content/utils.js';
import { getOrgSlug } from '../../../../../lib/utils.js';
import DownloadReportIcon from '../../../../icons/DownloadReportIcon.jsx';
import {
  formatedTemplate,
  generateSurveyPDF,
} from '../../../../../containers/change-insights/utils/index.jsx';

const mapStateToProps = (state) => ({
  permissions: selectUserPermissions(state),
});

const mapDispatchToProps = {
  deleteChangeInsightTemplate,
  createChangeInsight,
  retrieveTemplatesFeedbackForm,
  duplicateChangeInsightTemplate,
  updateAutoHiddenNotificationState,
};
const ChangeInsightTemplateActionDropdown = ({
  deleteChangeInsightTemplate,
  createChangeInsight,
  updateAutoHiddenNotificationState,
  permissions,
  surveyTemplate,
}) => {
  const slug = getOrgSlug();
  const [open, setOpen] = useState(false);

  const handleToggle = (isOpen) => {
    setOpen(isOpen);
  };

  const handleSelect = () => {
    setOpen(false);
  };

  const handleClickDeleteSurveyTemplate = () => {
    if (
      window.confirm(
        `Delete Feedback Form Template  \n\nAre you sure you want to delete this Feedback Form template? Action cannot be undone. If the feedback form template was used in a previous ${getOrgTermsContent('initiative')}, it won't be affected and will still be available for reporting.`
      )
    ) {
      deleteChangeInsightTemplate(surveyTemplate.id)
        .then(() => {
          updateAutoHiddenNotificationState({
            isShown: true,
            type: 'success',
            forPath: '/organization/custom-settings',
            message: 'Template copy was successfully deleted.',
          });
        })
        .catch((e) => {
          updateAutoHiddenNotificationState({
            isShown: true,
            type: 'danger',
            forPath: '/organization/custom-settings',
            message: `Error: ${e}`,
          });
        });
    }
  };

  const handleClickEditTemplate = (templateId) =>
    pushRoute(
      `/${slug}/organization/custom-settings/change-insights/edit/${templateId}`
    );

  const handleClickDuplicateTemplate = (template) => {
    const parsedTemplate = formatedTemplate(template);
    if (!parsedTemplate) {
      return;
    }
    parsedTemplate.title = `Copy of ${template.title}`;
    createChangeInsight({
      ...template,
      id: null,
      surveyJson: JSON.stringify(parsedTemplate),
      title: `Copy of ${template.title}`,
    })
      .then(() => {
        handleSelect();
        updateAutoHiddenNotificationState({
          isShown: true,
          type: 'success',
          forPath: '/organization/custom-settings',
          message: 'Template copy was successfully created.',
        });
      })
      .catch((e) => {
        updateAutoHiddenNotificationState({
          isShown: true,
          type: 'danger',
          forPath: '/organization/custom-settings',
          message: `Error: ${e}`,
        });
      });
  };

  return (
    <div className="actions">
      <DropdownButton
        noCaret
        title=""
        id="id"
        className="btn-more btn btn-default"
        open={open}
        onToggle={handleToggle}
        onSelect={handleSelect}
      >
        <span className="item">
          <MenuItem onClick={() => handleClickEditTemplate(surveyTemplate.id)}>
            <span className="flex">
              <EditBlueIcon />
              <span>&nbsp; Edit</span>
            </span>
          </MenuItem>
          <MenuItem divider />
        </span>
        <span className="item">
          <MenuItem
            onClick={() => handleClickDuplicateTemplate(surveyTemplate)}
          >
            <span className="flex">
              <DuplicateIcon />
              <span>&nbsp; Duplicate</span>
            </span>
          </MenuItem>
          <MenuItem divider />
        </span>
        <span className="item">
          <MenuItem
            onClick={() =>
              generateSurveyPDF({
                title: surveyTemplate.title,
                surveyJson: surveyTemplate.surveyJson,
              })
            }
          >
            <span className="flex">
              <DownloadReportIcon />
              <span>&nbsp; Download Template</span>
            </span>
          </MenuItem>
          <MenuItem divider />
        </span>
        {isAuthorized('update', 'surveyTemplate', permissions) ||
        isAuthorized('destroy', 'project', permissions) ? (
          <span className="item">
            <MenuItem onClick={handleClickDeleteSurveyTemplate}>
              <span className="flex">
                <DeleteBlueIcon />
                <span>&nbsp; Delete</span>
              </span>
            </MenuItem>
            <MenuItem divider />
          </span>
        ) : null}
      </DropdownButton>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeInsightTemplateActionDropdown);
